import React from "react";
import { Box } from "@mui/material";
import QualificationTable from "../../PORT/Qualification/QualificationTable";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

function QualificationContent({ segment, appraisalId, onFormFieldChange, appCode }) {
    const canUpdate = segment?.canUpdate ?? false;
    return (
        <Box component="div">
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
            <QualificationTable
                canUpdate={canUpdate}
                items={segment?.items ?? []}
                appraisalId={appraisalId}
                appCode={appCode}
            />
        </Box>
    );
}
export default QualificationContent;
